<vex-page-layout mode="card">
	<div *transloco="let t">
		<vex-page-layout-header class="pb-16 flex flex-col justify-center items-start">
			<div>
				<h1 class="title mt-0 mb-1">{{ t('development.development') }}</h1>
				<vex-breadcrumbs [crumbs]="this.breadCrumbService.crumbs"></vex-breadcrumbs>
			</div>
		</vex-page-layout-header>
		<vex-page-layout-content vexContainer>
			<div class="card p-6">
				<div @stagger class="no-scroll">
					<div class="section">
						<h2 class="page-title">
							{{ t('development.apiDocu') }}
						</h2>

						@for (section of apiSections; track section) {
							<div class="api-section">
								<div class="api-section-header">
									<h3 class="api-section-title">
										{{ t(section) }}
									</h3>
								</div>
								<div class="api-section-content">
									<div class="mb-4">
										<span class="item-label">{{ t('development.linkToApiDocu') }}:</span>
										<a [href]="argeExchangeUrl + '/swagger-ui/index.html'" target="_blank">
											{{ t('development.swagger') }}
										</a>
									</div>
									<div class="mb-4">
										<span class="item-label">URL:</span>
										{{ t('development.editionWithVersionInput') }}
										<br />
										<a [href]="argeExchangeUrl" target="_blank">{{ argeExchangeUrl }}</a>
										<br />
										{{ t('development.versionAddition') }}
									</div>
									<div class="mb-4">
										{{ t('development.editionWithoutVersionInput') }}
										<br />
										<a [href]="argeExchangeUrl" target="_blank">{{ argeExchangeUrl }}/v1.1</a>
									</div>
									<div class="mb-4">
										<span class="item-label">{{ t('development.authentication') }}:</span>
										{{ t('development.webServiceMethod') }}
										<br />
										{{ t('development.webServiceLogin') }}
									</div>
									<div class="mb-4">
										<span class="item-label">{{ t('development.realEstateActivationTitle') }}:</span>
										{{ t('development.realEstateActivation') }}
									</div>
								</div>
							</div>
						}

						<div class="api-section">
							<div class="api-section-header">
								<h3 class="api-section-title">
									{{ t('development.supportedRolesTitle') }}
								</h3>
							</div>
							<div class="api-section-content">
								<div class="mb-4">
									{{ t('development.supportedRoles') }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</vex-page-layout-content>
	</div>
</vex-page-layout>
